import { useState, useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { CardMedia, CardMediaProps } from '@mui/material';
// components
import LoadingScreen from "./LoadingScreen";

// ----------------------------------------------------------------------

type IBackgroundProps = {
  children: React.ReactNode;
  src: string;
};

type Props = IBackgroundProps & CardMediaProps;

const RootStyle = styled((props: CardMediaProps) => <CardMedia component="div" {...props} />)(
  ({ theme }) => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  })
);

export default function Background({ children, src, sx, ...other }: Props) {
  const [imageIsLoading, setImageIsLoading] = useState(true);

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      setImageIsLoading(false);
    };
    image.src = src;
  }, [src]);

  return (
    <RootStyle image={src} sx={{ ...sx }} {...other}>
      {!imageIsLoading ? children : <LoadingScreen />}
    </RootStyle>
  );
}
